module.exports = __webpack_public_path__ + "img/detail1.3884b6ba.jpg";